// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';

// Types
import { IRootState } from './types';

const initialState: IRootState = {
  shiftDetails: {} as IRootState['shiftDetails'],
  isShiftStarted: false,
  isBreakStarted: false,
  breakIndex: 0,
  personnelStatus: {},
};
export const slice = createSlice({
  name: STORE_SLICES.CLOCK,
  initialState,
  reducers,
});
const clockActions = slice.actions;

const clockPersistConfig = {
  key: PERSIST_KEYS.CLOCK,
  storage,
  whitelist: ['shiftDetails', 'breakIndex', 'isShiftStarted'],
};

export {
  clockActions,
};

export default persistReducer(clockPersistConfig, slice.reducer);
